import { cognito } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import * as LS from 'helpers/localStorage';
import { call, put } from 'redux-saga/effects';
import { emergentModal } from 'store/features/modal';

import { authSignIn } from './authSignIn';
import { configFetch } from './configFetch';
import { fetchRegister } from './fetchRegister';
import { userFetch } from './userFetch';

export const authSignOut = createApiSlice({
  name: 'authSignOut',
  *tryGenerator() {
    yield call(cognito.signOut);

    yield put(emergentModal.actions.reset());

    yield put(authSignIn.actions.reset());
    yield put(userFetch.actions.reset());
    yield put(configFetch.actions.reset());
    yield put(fetchRegister.actions.reset());

    // remove from localStorage
    LS.remove();

    return null;
  },
});
